<div class="card m-0 bg-transparent">
  <div class="card-body">
    <form [formGroup]="labelform">
      <div class="row d-flex justify-content-between align-items-center mb-3">
        <div class="col-12 m-0">
          <label
            for="text-color"
            class="offcanvas-header-text w-100"
            style="text-align: left"
          >
            {{ config?.name }}
          </label>
          <select
            id="selectoption"
            class="form-select offcanvas-primary ng-pristine ng-valid ng-touched border-0 shadow-none"
            formControlName="position"
            (change)="changePosition()"
          >
            <option value="single">Single</option>
            <option value="top">Top</option>
            <option value="middle">Middle</option>
            <option value="bottom">bottom</option>
          </select>
        </div>
      </div>
    </form>
  </div>
</div>
